
import { validationMixin } from 'vuelidate';
import user_mixin from '~/mixins/user_mixin';
import coupon_mixin from '~/mixins/coupon_mixin';
import shop_mixin from '~/mixins/shop_mixin';
import error_reporting, { MODULES } from '../mixins/error_reporting';
import moment from 'moment-timezone';
import {
  required,
  email,
  sameAs,
  minLength,
  maxLength,
  helpers
} from 'vuelidate/lib/validators';
const alpha = helpers.regex('alpha', /^[a-zA-Z ]*$/);
import { initiatePayment } from '~/lib/paymentGateways';
import { events, trackEvent, onUserLogin } from '@/lib/clevertap';
import { mapState, mapMutations } from 'vuex';
import { COUPON_ERROR_MAP, COUPON_ERROR_MESSAGES } from '@/lib/constants';
import {
  mdiEye,
  mdiEyeOff,
  mdiCheckBold,
  mdiCursorPointer,
  mdiCalendar
} from '@mdi/js';

export default {
  mixins: [
    validationMixin,
    user_mixin,
    coupon_mixin,
    shop_mixin,
    error_reporting
  ],
  name: 'CreateAccount',
  props: [
    'title',
    'paymentOption',
    'defaultPlan',
    'hideFreeTrial',
    'redirectTo'
  ],
  data() {
    return {
      dialog: false,
      isSuccess: true,
      submitted: false,
      valid: false,
      showPassword: false,
      confPassword: false,
      isCurrencyDetected: false,
      parent_name: '',
      phone_number: '',
      countryCode: 91,
      countryId: 81,
      countries: [],
      currrencyList: [],
      currency: 'USD',
      countryCodeText: 'US',
      countryName: 'United States',
      email: '',
      password: '',
      repeatPassword: '',
      referral_code: null,
      referred_by: null,
      referralDialog: false,
      referralFailedDialog: false,
      params: '',
      isUserExists: false,
      id: 0,
      child_name: '',
      coupon_code: '',
      plans: [],
      plan: {},
      date_of_birth: new Date('2014-07-01').toJSON().slice(0, 10),
      modal: false,
      isReferralDiscount: false,
      logoImage: null,
      redirectUrl: '/parents/mykids',
      button_title: 'Create Account',
      isPaymentMode: this.paymentOption,
      defaultCountry: { currency: 'IN', country_code: 'IN' },
      couponApplied: false,
      giftSubscription: false,
      giftToken: null,
      referral: {
        applied: false
      },
      buttonLoading: false,
      freeTrialBtnLoading: false,
      eventsToTrack: {},
      icons: {
        mdiEye,
        mdiEyeOff,
        mdiCheckBold,
        mdiCursorPointer,
        mdiCalendar
      },
      couponPlanName: '',
      countrySelectionDisabled: false,
      orderId: null
    };
  },
  async mounted() {
    try {
      const keys = Object.keys(this.$route.query);
      if (keys.length) {
        const key = keys.find(obj => obj.toLowerCase().indexOf('code') >= 0);
        if (key) {
          this.params = key.toLowerCase();
        }
      }

      if (this.$route.query.referralCode) {
        let referral_code = this.$route.query.referralCode;
        this.$api.users
          .find({ referral_code })
          .then(resp => {
            if (resp && resp.data && resp.data.length == 1) {
              this.referral_code = referral_code;
              this.referred_by = resp.data[0].id;
            } else this.referralFailedDialog = true;
          })
          .catch(error => {
            this.referralFailedDialog = true;
          });
      }

      const countries = await this.$api.countries.find({
        $paginate: false,
        controller: 'country-code'
      });

      this.countries = countries.map(obj =>
        Object.assign(obj, {
          countryCode: '+' + obj.code,
          country: obj.country_code
        })
      );

      try {
        const getlocation_data = await this.$api.geoLocationService.get();

        // const getlocation_data = await this.$axios.$get(
        //   process.env.GEO_LOCATION_URL
        // );
        this.isCurrencyDetected = true;
        this.countryCodeText = getlocation_data.country_code;
        this.countryName = getlocation_data.country;

        let country = this.countries.find(
          ({ country }) => country === this.countryCodeText
        );
        if (country) {
          this.countryCode = country.code;
          this.countryId = country.id;
          this.countrySelectionDisabled = true;
        } else {
          this.countryCode = 1;
          this.countryId = 841;
        }
      } catch (error) {
        this.countryCodeText = 'US';
      }

      const res = await this.$api.countries.getPaymentSupportedCountries();
      this.currrencyList = res || [];

      await this.findCountry();
      const { coupon } = this.$route.query;
      if (coupon) {
        this.coupon_code = coupon;
        await this.useCoupon({ couponCode: true });
      }
      this.logoImage = window.location.origin + '/logo.png';
      if (this.paymentOption) {
        this.button_title = `Pay ${this.currency} ${this.plan.rate}`;
      } else if (this.params === 'giftcode') {
        this.button_title = 'Claim Your Gift';
        this.giftSubscription = true;
        this.giftToken = this.$route.query.giftcode;
      }
      if (this.params === 'referralcode' && !this.referralFailedDialog) {
        this.referral = {
          applied: true,
          discount_rate: 10,
          discount_type: 'Percentage',
          maximum_discount_amount: 5000
        };

        this.bulkDiscount();
      }
    } catch (error) {
      console.log('error', error);
      this.reportError({ tags: { module: MODULES.SIGNUP }, error: error });
    }
  },

  validations: {
    parent_name: { required, alpha },
    email: { required, email },
    phone_number: { required, maxLength: maxLength(15) },
    countryCode: { required },
    countryId: { required },
    // min 6 & max 16
    // 1 upper case, 1 lower case, 1 digit
    password: {
      required,
      minLength: minLength(4)
      // maxLength: maxLength(16),
      // valid: function(value) {
      //   const containsUppercase = /[A-Z]/.test(value);
      //   const containsLowercase = /[a-z]/.test(value);
      //   const containsNumber = /[0-9]/.test(value);
      //   return containsUppercase && containsLowercase && containsNumber;
      // }
    },
    repeatPassword: {
      required,
      sameAsPassword: sameAs('password')
    },
    child_name: { required, alpha }
  },
  computed: {
    buttonTitle() {
      try {
        if (this.paymentOption && this.plan.rate) {
          this.button_title = `Pay ${this.currency} ${this.plan.rate}`;
      } else if (this.params === 'giftcode') {
        this.button_title = 'Claim Your Gift';
        }
        return this.button_title;
      } catch (err) {
        this.reportError({ tags: { module: MODULES.SIGNUP }, error: err });
        throw err;
      }
    },
    nameErrors() {
      try {
        const errors = [];
        if (!this.$v.parent_name.$dirty) return errors;
      !this.$v.parent_name.required && errors.push('Parent name is required');
      !this.$v.parent_name.alpha && errors.push('Invalid name');
        return errors;
      } catch (err) {
        this.reportError({ tags: { module: MODULES.SIGNUP }, error: err });
        throw err;
      }
    },
    emailErrors() {
      try {
        const errors = [];
        if (!this.$v.email.$dirty) return errors;
      !this.$v.email.email && errors.push('Must be valid e-mail');
      !this.$v.email.required && errors.push('E-mail is required');
        return errors;
      } catch (err) {
        this.reportError({ tags: { module: MODULES.SIGNUP }, error: err });
        throw err;
      }
    },
    phoneErrors() {
      try {
        const errors = [];
        if (!this.$v.phone_number.$dirty) return errors;
      !this.$v.phone_number.required && errors.push('Phone number is required');
      !this.$v.phone_number.maxLength && errors.push('Maximum length exceed');
        return errors;
      } catch (err) {
        this.reportError({ tags: { module: MODULES.SIGNUP }, error: err });
        throw err;
      }
    },
    codeErrors() {
      try {
        if (this.submitted) {
          const errors = [];
          if (!this.$v.countryId.$dirty) return errors;
        !this.$v.countryId.required && errors.push('Country code is required');
          return errors;
        }
      } catch (err) {
        this.reportError({ tags: { module: MODULES.SIGNUP }, error: err });
        throw err;
      }
    },
    passwordErrors() {
      try {
        if (this.submitted) {
          const errors = [];
          if (!this.$v.password.$dirty) return errors;
        !this.$v.password.required && errors.push('Password is required');
          !this.$v.password.minLength &&
          errors.push('Password must have atleast 4 letters');
          // !this.$v.password.maxLength &&
          //   errors.push('Password must have at most 16 letters');
          // !this.$v.password.valid &&
          //   errors.push(
          //     'Password must contain 1 uppercase, 1 lowercase & 1 digit'
          //   );
          return errors;
        }
      } catch (err) {
        this.reportError({ tags: { module: MODULES.SIGNUP }, error: err });
        throw err;
      }
    },
    confPasswordErrors() {
      try {
        const errors = [];
        if (!this.$v.repeatPassword.$dirty) return errors;
        !this.$v.repeatPassword.required &&
        errors.push('Confirm Password is required');
        !this.$v.repeatPassword.sameAsPassword &&
        errors.push('Password is not identical');
        return errors;
      } catch (err) {
        this.reportError({ tags: { module: MODULES.SIGNUP }, error: err });
        throw err;
      }
    },
    childNameErrors() {
      try {
        const errors = [];
        if (!this.$v.child_name.$dirty) return errors;
      !this.$v.child_name.required && errors.push('Child name is required');
      !this.$v.child_name.alpha && errors.push('Invalid name');
        return errors;
      } catch (err) {
        this.reportError({ tags: { module: MODULES.SIGNUP }, error: err });
        throw err;
      }
    },
    ...mapState('general', ['paymentStatus'])
  },
  watch: {
    paymentStatus(newVal) {
      try {
        const orderDetails = newVal.find(el => el.orderId === this.orderId);
        if (orderDetails) {
        if (orderDetails.status === 'success') {
            this.$notifier.showMessage({
            content: 'Payment success',
            color: 'success'
            });
            this.deletePaymentStatus({ orderId: this.orderId });
            this.processSuccessfulPayment(orderDetails);
        } else if (orderDetails.status === 'failed') {
            trackEvent(events.SUBSCRIPTION_ATTEMPTED, {
              email: this.$auth.user.email,
              plan_name: this.selectedPlan.plan_name,
              price: parseInt(this.selectedPlan.rate),
              currency: this.defaultCountry.currency
            });
            this.$notifier.showMessage({
            content: 'Payment failed please retry after some time',
            color: 'error'
            });
        } else if (orderDetails.status === 'error') {
            this.$notifier.showMessage({
              content: orderDetails.message,
            color: 'error'
            });
            this.deletePaymentStatus({ orderId: this.orderId });
          }
        }
      } catch (err) {
        this.reportError({ tags: { module: MODULES.SIGNUP }, error: err });
        throw err;
      }
    }
  },
  methods: {
    ...mapMutations('general', ['addPaymentStatus', 'deletePaymentStatus']),
    ...mapMutations('global', ['setCleverTapSession']),
    async findCountry() {
      try {
        const defaultCountry = this.currrencyList.find(
          row => row.country_code === this.countryCodeText
        );
        if (defaultCountry) {
          this.defaultCountry = defaultCountry;
          this.currency = defaultCountry.currency;
        } else {
        this.currency = 'USD';
          this.defaultCountry = this.countries.find(
          row => row.currency === 'USD'
          );
        }

        const plans = await this.$api.plans.find({
        controller: 'plans-by-country',
          countryId: this.defaultCountry.id
        });

        this.plans = plans.map(plan => {
          let planRate = { rate: 0 };
          if (plan.planRates.length) planRate = plan.planRates[0];
          else planRate.plan_id = plan.id;

          let updated = { ...plan, ...planRate };

          updated.rate = updated.rate.toFixed(2);
          updated.original = updated.rate;
          updated.discount = 0;

          return updated;
        });
      let plan = this.plans.find(plan => plan.is_default === 'Y');
        if (plan) this.plan = plan;

        if (!this.isCurrencyDetected && this.couponApplied) {
          this.useCoupon();
        }
      } catch (err) {
        this.reportError({ tags: { module: MODULES.SIGNUP }, error: err });
        throw err;
      }
    },
    bulkDiscount() {
      try {
        this.plans = this.plans.map(row => {
          const amt = row.original;
          const discount = this.calculate_discount(
            amt,
            this.referral.discount_rate,
            this.referral.discount_type,
            this.referral.maximum_discount_amount
          );

          row.discount = discount;
          row.rate = (row.original - discount).toFixed(2);
          return row;
        });
      } catch (err) {
        this.reportError({ tags: { module: MODULES.SIGNUP }, error: err });
        throw err;
      }
    },
    resetPlanPayment() {
      try {
        this.couponApplied = false;
        this.plans = this.plans.map(plan => {
          plan.discount = 0;
          plan.rate = plan.original;

          return plan;
        });
      } catch (err) {
        this.reportError({ tags: { module: MODULES.SIGNUP }, error: err });
        throw err;
      }
    },
    async useCoupon({ couponCode }) {
      try {
        if (!couponCode && this.$v.$invalid) {
          this.showSnackbar(
          'You have missed some fields. Kindly enter your details to proceed'
          );
          return;
        }
        try {
          const res = await this.claimCoupon(
            this.coupon_code,
            this.defaultCountry.id,
            {
              email: this.email,
              phone: {
                country_code: this.countryCode,
                phone_number: this.phone_number
              }
            }
          );

          this.couponApplied = true;
          const offers = res.plans;
          this.offer_id = res.offerId;
          this.plans = this.plans.map(plan => {
            const offer = offers.find(o => o.plan_id === plan.plan_id);
            if (offer) {
              plan.discount = offer.discount;
              plan.rate = offer.discounted_rate;
            } else {
              plan.discount = 0;
              plan.rate = plan.original;
            }
            return plan;
          });
        this.couponPlanName = offers.map(o => o.plan_name).join(', ');

          if (this.couponApplied) this.eventsToTrack.COUPON_APPLIED = true;
        } catch (error) {
        this.coupon_code = '';
          this.couponApplied = false;
          this.plans = this.plans.map(plan => {
            plan.discount = 0;
            plan.rate = plan.original;

            return plan;
          });

          const errorRespData = error?.response?.data;
          if (errorRespData && errorRespData.code === 406) {
            const reason =
              errorRespData?.data?.reason || COUPON_ERROR_MAP.INVALID_COUPON;
            const data = errorRespData?.data || {};
            this.$notifier.showMessage({
              content: COUPON_ERROR_MESSAGES[COUPON_ERROR_MAP[reason]](data),
            color: 'error'
            });
          }
        }
      } catch (err) {
        this.reportError({ tags: { module: MODULES.SIGNUP }, error: err });
        throw err;
      }
    },
    trackCouponEvent(eventName) {
      try {
        trackEvent(eventName, {
          date: new Date(),
          child_name: this.child_name,
          coupon_code: this.coupon_code,
          plans: this.couponPlanName
        });
      } catch (err) {
        this.reportError({ tags: { module: MODULES.SIGNUP }, error: err });
        throw err;
      }
    },
    closeUserExists() {
      this.isUserExists = false;
      this.$router.replace('/login');
    },
    async closeModal() {
      this.$router.replace('/parents/mykids');
    },
    gotoLogin() {
      let url = '/login';
      if (this.params === 'giftcode') {
        url += `?${this.params}=${this.$route.query[this.params]}`;
      }
      this.$router.replace(url);
    },
    validate() {
      return this.$refs.form.validate();
    },
    reset() {
      this.$refs.form.reset();
    },
    resetValidation() {
      this.$refs.form.resetValidation();
    },
    async submitOrder(data) {
      try {
        return await this.$api.order.create(data);
      } catch (err) {
        this.reportError({ tags: { module: MODULES.SIGNUP }, error: err });
        throw err;
      }
    },
    async verifyOrder(id, data) {
      try {
        return await this.$api.order.patch(id, data);
      } catch (err) {
        this.reportError({ tags: { module: MODULES.SIGNUP }, error: err });
        throw err;
      }
    },
    async addUser(data) {
      try {
        const user = await this.$api.users.create(data.users);
        await this.doAutoLogin();
        data.user_profiles.user_id = this.$auth.user.id;
        const child = await this.$api.userProfile.create(data.user_profiles);
        this.student_id = child.id;

        this.trackAllEvents();
        // if (this.couponApplied && this.plan.id !== 6)
        //   this.trackCouponEvent(events.COUPON_USED);

        await this.$auth.fetchUser();
        this.$sentry.setUser({
          email: this.$auth.user.email,
          id: this.$auth.user.user_profile[0].id,
          childId:
            this.$route.query.child_id ?? this.$auth.user.user_profile[0].id
        });
        this.setChild(this.$auth.user.user_profile[0]);
        await this.mergeUnregisteredUserCart();
        if (!data.paymentWait) {
          this.postLogin(user);
        }
      } catch (error) {
        if (error.response.data.message === 'User already exist') {
          this.id = error.response.data.data.id;
          this.isUserExists = true;
          this.showSnackbar('User already Exists, Please login');
        } else {
          this.showSnackbar('Some error occured please try after some time');
          this.reportError({ tags: { module: MODULES.SIGNUP }, error: error });
        }
      }
    },
    async trackAllEvents() {
      // console.log(this.eventsToTrack);
      try {
        await onUserLogin(this.$auth.user);
        this.setCleverTapSession(true);
        if (this.eventsToTrack.FREE_TRIAL_USER) {
          // Track Free Trial User
          // trackEvent(events.FREE_TRIAL_USER, {
          //   email: this.email,
          //   name: this.parent_name,
          //   mobile: this.phone_number,
          //   platform: "web",
          //   date: new Date()
          // });
        }

        if (this.eventsToTrack.SIGNUP_WITH_REFFERAL) {
          // Track Refferal
          trackEvent(events.SIGNUP_WITH_REFFERAL, {
            email: this.email,
            name: this.parent_name,
            mobile: this.phone_number,
          platform: 'web',
            date: new Date(),
            child_name: this.child_name,
            date_of_birth: this.date_of_birth,
            school: this.institute_name,
            gender: this.gender,
            plan_name: this.plan.plan_name,
            price: this.plan.rate,
            currency: this.currency,
            referral_code: this.referral_code,
            country_name: this.countryName
          });
        }
        if (this.eventsToTrack.SIGNUP_WITHOUT_PAYMENT) {
          // Track signup without payment event
          trackEvent(events.SIGNUP_WITHOUT_PAYMENT, {
            email: this.email,
            name: this.parent_name,
            mobile: this.phone_number,
          platform: 'web',
            date: new Date(),
            child_name: this.child_name,
            date_of_birth: this.date_of_birth,
            country_name: this.countryName
          });
        }

        if (this.eventsToTrack.SIGNUP_WITH_PAYMENT) {
          // Track signup with payment event
          trackEvent(events.SIGNUP_WITH_PAYMENT, {
            email: this.email,
            name: this.parent_name,
            mobile: this.phone_number,
          platform: 'web',
            date: new Date(),
            child_name: this.child_name,
            date_of_birth: this.date_of_birth,
            plan_name: this.plan.plan_name,
            price: parseInt(this.plan.rate),
            currency: this.currency,
            country_name: this.countryName
          });
        }

        if (this.eventsToTrack.PURCHASE_SUBSCRIPTION) {
          // Track Purchase
          trackEvent(events.PURCHASE_SUBSCRIPTION, {
            email: this.email,
            name: this.parent_name,
            mobile: this.phone_number,
            date: new Date(),
            child_name: this.child_name,
            plan_name: this.plan.plan_name,
            price: parseInt(this.plan.rate),
            currency: this.currency,
            country_name: this.countryName
          });
        }

        if (this.eventsToTrack.COUPON_APPLIED) {
          this.trackCouponEvent(events.COUPON_APPLIED);
        }
      } catch (err) {
        this.reportError({ tags: { module: MODULES.SIGNUP }, error: err });
        throw err;
      }
    },
    async validateExistingEmail() {
      try {
        const res = await this.$api.users.find({
          email: this.email
        });
        return res.total === 0;
      } catch (err) {
        this.reportError({ tags: { module: MODULES.SIGNUP }, error: err });
        throw err;
      }
    },
    async validateExistingPhone() {
      try {
        const res = await this.$api.users.find({
          phone_number: `${this.phone_number}`,
          country_code: this.countryCode
        });

        return res.total === 0;
      } catch (err) {
        this.reportError({ tags: { module: MODULES.SIGNUP }, error: err });
        throw err;
      }
    },
    async doValidations() {
      try {
        this.$v.$touch();
        if (this.$v.$invalid) {
          this.showSnackbar(
          'You have missed some fields. Kindly enter your details to proceed'
          );
          return false;
        }

        if (!this.validate()) return false;

        if (this.giftSubscription === true) {
          const gift = await this.$api.giftSubscription.find({
            token: this.giftToken
          });
          if (!gift || gift.data[0].subscriber_email !== this.email) {
          this.showSnackbar('Your email is invalid for this gift!');
            return false;
          }
        }

        const emailStatus = await this.validateExistingEmail();
        if (!emailStatus) {
        this.showSnackbar('Email already exist!');
          return false;
        }

        const phoneStatus = await this.validateExistingPhone();
        if (!phoneStatus) {
        this.showSnackbar('Phone Number already exist!');
          return false;
        }

        return true;
      } catch (err) {
        this.reportError({ tags: { module: MODULES.SIGNUP }, error: err });
        throw err;
      }
    },
    async subscribeUser() {
      try {
        this.buttonLoading = true;
        // stop here if form is invalid
        const validData = await this.doValidations();
        if (!validData) {
          this.buttonLoading = false;
          return;
        }

        this.onSubmit();
      } catch (err) {
        this.reportError({ tags: { module: MODULES.SIGNUP }, error: err });
        throw err;
      }
    },
    async onSelectFreeTrial() {
      try {
        this.freeTrialBtnLoading = true;
        const validData = await this.doValidations();
        if (!validData) {
          this.freeTrialBtnLoading = false;
          return;
        }

        this.plan = this.plans.find(plan => plan.free_plan === 1);
        this.onSubmit();
      } catch (err) {
        this.reportError({ tags: { module: MODULES.SIGNUP }, error: err });
        throw err;
      }
      // this.eventsToTrack.FREE_TRIAL_USER = true;
    },
    async onSubmit() {
      try {
        this.submitted = true;
        this.valid = false;
      let names = this.child_name.split(' ');
        let first_name = names[0];
      let last_name = names[1] ? names[1] : '';

        let dataToSubmit = {
          users: {
            parent_name: this.parent_name,
            email: this.email,
            phone_number: `${this.phone_number}`,
            password: this.password,
            country_code: this.countryCode,
            country_id: this.countryId,
          role: 'Parent',
            email_verified: 1,
          signup_from: 'web'
          },
          user_profiles: {
            user_id: 0,
            name: this.child_name,
            date_of_birth: this.date_of_birth,
            institute_name: this.institute_name,
            institute_id: 0,
            gender: this.gender,
            current_level: 0,
          institute_name: ''
          }
        };
        if (this.referral_code) {
          dataToSubmit.users.referred_by = this.referred_by;
          this.eventsToTrack.SIGNUP_WITH_REFFERAL = true;
        }

      if (this.paymentOption && currentPlanPayablePrice !== 0 )
        dataToSubmit.paymentWait = true;
      await this.addUser(dataToSubmit);

        const currentPlanPayablePrice = parseInt(this.plan.rate);
        if (this.paymentOption) {
          const orderRequest = {
            countryId: this.defaultCountry.id,
          paymentMode: currentPlanPayablePrice === 0 ? 'offer' : 'razorpay',
            firstName: first_name,
            lastName: last_name,
            email: this.email,
            ownerEmail: this.email,
            planId: this.plan.plan_id,
            couponCode: this.couponApplied ? this.coupon_code : null,
            referralCode: this.referral_code || null,
          type: this.referral_code ? 'referral' : 'directPayment',
          platform: 'web',
            phoneNumber: this.phone_number,
            countryCode: this.countryCode,
            extraAttr: JSON.stringify({
            page: 'signup',
              childDOB: this.date_of_birth
            })
          };
          const order = await this.submitOrder(orderRequest);
          this.orderId = order.id;
        if (order.payment_mode === "offer") {
          // const resp = await this.$api.subscription.create({
          //   orderId: order.id,
          //   childId: this.student_id
          // });
          this.processSuccessfulPayment(order.subscriptionResponse);
          } else {
          this.addPaymentStatus({ orderId: this.orderId, status: "pending" });
            let $this = this;
            this.$chatSocket.init(this.student_id);
            this.$multiplayerSocket.init(this.selectedUserProfile.id);
            this.$chatSocket.sendPaymentMessage({ orderId: this.orderId });
            await initiatePayment({
            paymentMode: 'razorpay',
            order,
            description: this.plan.description,
            logoImage: this.logoImage,
            onPaymentSuccess: async response => {
              // const successfulOrder = await this.verifyOrder(
              //   order.id,
              //   response
              // );
              // this.fetchChildAndAddSubscription(successfulOrder);
            },
            onPaymentDismiss: function () {
              $this.showSnackbar('Payment is declined by user');
              trackEvent(events.SUBSCRIPTION_ATTEMPTED, {
                email: $this.email,
                plan_name: $this.plan.plan_name,
                price: $this.plan.rate,
                currency: $this.currency
              });
              this.deletePaymentStatus({ orderId: this.orderId });
            },
            onPaymentFailed: function () {
              $this.showSnackbar('Payment failed please retry after some time');
              }
            });
            this.buttonLoading = false;
          }
        } else {
          this.eventsToTrack.SIGNUP_WITHOUT_PAYMENT = true;
        }
      } catch (err) {
        this.reportError({ tags: { module: MODULES.SIGNUP }, error: err });
        throw err;
      }
    },
    async fetchChildAndAddSubscription(order) {
      await this.$auth.fetchUser();
      this.setChild(this.$auth.user.user_profile[0]);
      if (this.plan.free_plan === 1)
        this.$router.push('/parents/thank-you?freeTrial=1');
      else this.$router.push('/parents/thank-you');
    },
    async doAutoLogin() {
      try {
        await this.$auth.loginWith('local', {
          data: {
          strategy: 'local',
            email: this.email,
            password: this.password
          }
        });
      } catch (err) {
        this.reportError({ tags: { module: MODULES.SIGNUP }, error: err });
        throw err;
      }
    },
    async postLogin(user) {
      try {
        await this.$auth.fetchUser();

        switch (this.params) {
          case 'verifyemail':
            this.$router.replace(this.redirectUrl);
            break;
          case 'giftcode':
            this.$router.replace('/myplan');
            break;
          case 'referralcode':
            this.referralDialog = true;
            break;
          default:
            this.$router.replace('parents/mykids');
            break;
        }
      } catch (error) {
        console.log('error==>', errror);
        this.reportError({ tags: { module: MODULES.SIGNUP }, error: error });
      }
    },
    async resendLink() {
      try {
        const response = await this.$api.users.patch(this.id, {
        controller: 'sendVarificationMail'
        });
        this.isUserExists = false;
      } catch (err) {
        this.reportError({ tags: { module: MODULES.SIGNUP }, error: err });
        throw err;
      }
    },
    showSnackbar(message) {
      this.$notifier.showMessage({
        content: message,
        color: 'error'
      });
    },
    setCountryCodeFromId() {
      try {
        this.countryCode = this.countries.find(
          country => country.id === this.countryId
        )?.code;
      } catch (err) {
        this.reportError({ tags: { module: MODULES.SIGNUP }, error: err });
        throw err;
      }
    },
    getSelectedCountryName(item) {
      let name = '';
      if (item.name.length > 10) name = item.name.substring(0, 9) + '...';
      else name = item.name;
      return `${name} (+${item.code})`;
    },
    isFlagImageExist(countryCode) {
      let imageExist = false;
      try {
        require(`~/assets/images/countries/${countryCode}.svg`);
        imageExist = true;
      } catch (err) {}
      return imageExist;
    },
    async processSuccessfulPayment(orderDetails) {
      try {
        const redirectTo = this.redirectTo;
        let redirectUrl = '/parents/thank-you';
        if (this.plan.free_plan === 1) {
          redirectUrl = '/parents/thank-you?freeTrial=1';
        }
        if (redirectTo && redirectTo === 'cart') {
          redirectUrl = '/shop/cart';
        }
        await this.$auth.fetchUser();
        this.setChild(this.$auth.user.user_profile[0]);
        if (orderDetails.subscriptionPoints || orderDetails.pointsCredited) {
          const eventData = {
            child_name: this.$auth.user.user_profile[0].name,
            points:
              orderDetails.subscriptionPoints ?? orderDetails.pointsCredited,
            date: new Date(),
          platform: 'web'
          };
          trackEvent(events.POINTS_EARNED, eventData);
        }
        await this.$router.push(redirectUrl);
      } catch (err) {
        this.reportError({ tags: { module: MODULES.SIGNUP }, error: err });
        throw err;
      }
    }
  }
};
